/* ***************************************************************** */
/* TODO: eslint pre-existing exceptions auto generated on 2022-09-08 */
/*       Do not add to these rule exceptions. Only remove as the     */
/*       violations are cleaned from our code.                       */
/*                                                                   */
/*       eslint-disable default-param-last                           */
/* ***************************************************************** */
import { ScopedType } from './scoped-type';
import * as service from '../../services/eoy-report-service';

const Type = ScopedType('EOY_REPORT');
const REPORTS_LOAD_START = Type('REPORTS_LOAD_START');
const REPORTS_LOADED = Type('REPORTS_LOADED');
const REPORTS_LOAD_FAILED = Type('REPORTS_LOAD_FAILED');
const REPORT_GENERATE_START = Type('REPORTS_GENERATE_START');
const REPORT_GENERATE_FAILED = Type('REPORTS_GENERATE_FAILED');

const SLICE = 'eoyReport';

export const selectors = {
  reports: (state) => state[SLICE].reports,
};

export const reducers = {
  eoyReport: eoyReportReducer,
};

export const actions = {
  loadReports,
  generateReport,
};

function loadReports(growerId) {
  return async (dispatch) => {
    try {
      dispatch({ type: REPORTS_LOAD_START });
      const reports = await service.getReports(growerId);
      dispatch({ type: REPORTS_LOADED, payload: reports });
    } catch (e) {
      dispatch({ type: REPORTS_LOAD_FAILED, payload: e });
    }
  };
}

function generateReport(growerId, year, skipQc) {
  return async (dispatch) => {
    try {
      dispatch({ type: REPORT_GENERATE_START, payload: year });
      await service.generateReport(growerId, year, skipQc);
    } catch (e) {
      dispatch({ type: REPORT_GENERATE_FAILED, payload: year });
    }
  };
}

function eoyReportReducer(state = {}, { type, payload }) {
  if (type === REPORTS_LOAD_START) {
    return { ...state, reports: null };
  }

  if (type === REPORTS_LOADED) {
    return { ...state, reports: payload };
  }

  if (type === REPORT_GENERATE_START) {
    return updateReport(state, {
      year: payload,
      status: 'In Queue',
      link: null,
      isRunning: true,
    });
  }

  if (type === REPORT_GENERATE_FAILED) {
    return updateReport(state, {
      year: payload,
      status: 'Failed: unable to submit job',
      isRunning: false,
    });
  }

  return state;
}

function updateReport(state, patch) {
  return {
    ...state,
    reports: state.reports.map((report) => {
      if (report.year === patch.year) return { ...report, ...patch };
      return report;
    }),
  };
}
